import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Header from "../Header";
import Warning from "../../../../../../Components/common/Warning/Warning";
import Spinner from "../../../../../../Components/common/Spinner/Spinner";
import Tooltip from "../../../../../../Components/common/Tooltip/Tooltip";

import {
  RequestRepairAgentPolicy,
  RequestResetAgentPolicy,
} from "../../../../../../store/actions/integrationsActions";

const ResetForm = ({ selectedHost }) => {
  const dispatch = useDispatch();

  const policy = useSelector((state) => state.integrations.agentPolicy);
  const resetPolicyLoading = useSelector((state) => state.integrations.resetPolicyLoading);
  const repairPolicyLoading = useSelector((state) => state.integrations.repairPolicyLoading);

  const [showWarning, setShowWarning] = useState(false);
  const [showWarningRepair, setShowWarningRepair] = useState(false);

  const handleResetSettings = (e) => {
    e.preventDefault();
    if (resetPolicyLoading) return;

    dispatch(
      RequestResetAgentPolicy({
        id: policy.id,
        host: selectedHost,
        onFinish: () => setShowWarning(false),
      }),
    );
  };

  const handleRepairSettings = (e) => {
    e.preventDefault();
    if (repairPolicyLoading) return;

    dispatch(
      RequestRepairAgentPolicy({
        id: policy.id,
        host: selectedHost,
        onFinish: () => setShowWarningRepair(false),
      }),
    );
  };

  return (
    <>
      <Header
        policy={policy}
        selectedHost={selectedHost}
        toggleProps={{
          show: false,
        }}
      />

      <form className="agent-policy-form">
        <p className="agent-policy-form__label">
          Reset Policy Configs
          <Tooltip
            text="Click the button below to reset the configs of this policy in the agenter"
            showFlowGrow={false}
          />
        </p>
        <button
          type="button"
          className="reset-button danger-button"
          onClick={() => {
            setShowWarning(true);
          }}>
          {resetPolicyLoading ? <Spinner width={14} height={14} /> : "Reset Policy Configs"}
        </button>

        <br />

        <p className="agent-policy-form__label">
          Repair and Update Policy Configs
          <Tooltip
            text="Click the button below to repair the configs of this policy in the agenter"
            showFlowGrow={false}
          />
        </p>
        <button
          type="button"
          className="reset-button default-button"
          onClick={() => {
            setShowWarningRepair(true);
          }}>
          {repairPolicyLoading ? <Spinner width={14} height={14} /> : "Repair Policy Configs"}
        </button>

        <Warning
          onClickOk={handleResetSettings}
          show={showWarning}
          setShow={setShowWarning}
          text={`If you click yes, configs of this policy will be reset. Are you sure to reset policy configs ?`}
          article={`Confirm Reset Policy Configs`}
          cancelDisable={false}
        />
        <Warning
          onClickOk={handleRepairSettings}
          show={showWarningRepair}
          setShow={setShowWarningRepair}
          text={`If you click yes, configs of this policy will be repaired. Are you sure to repair policy configs ?`}
          article={`Confirm Repair and Update Policy Configs`}
          cancelDisable={false}
        />
      </form>
    </>
  );
};

export default ResetForm;
